<template>
  <div class="table-container">
    <table class="table is-fullwidth is-striped">
      <thead>
        <tr>
          <th>Event</th>
          <th>Site</th>
          <th>Owner</th>
          <th>Started</th>
          <th>Ended</th>
          <th>Wiped</th>
          <th>Stocked</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!rows.length">
          <td colspan="7" class="has-text-grey">No history yet.</td>
        </tr>
        <tr v-for="row in rows" :key="row.id">
          <td>{{ kinds[row.kind] || row.kind }}</td>
          <td>{{ row.camera_id ? row.camera_name || `#${row.camera_id}` : "—" }}</td>
          <td>{{ row.owner_company_id ? row.owner_company_name || `#${row.owner_company_id}` : "Natilon" }}</td>
          <td>{{ formatDate(row.started_at) || "—" }}</td>
          <td>{{ row.camera_id ? formatDate(row.ended_at) || "Current" : "—" }}</td>
          <td>{{ formatDate(row.wiped_at) || "—" }}</td>
          <td>{{ formatDate(row.stocked_at) || "—" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatDate } from "@/utils/date_converter";
import { OWNERSHIP_KINDS } from "@/utils/pro_camera";

export default {
  name: "ProCameraSitesTab",
  props: {
    deviceData: { type: Object, default: () => ({}) },
  },
  data() {
    return { kinds: OWNERSHIP_KINDS };
  },
  computed: {
    rows() {
      return this.deviceData.ownership || [];
    },
  },
  methods: { formatDate },
};
</script>
